import React from "react";
import { Row, Col } from "antd";

import { Container, CustomCard } from "./styled";
import { services as cards } from "../../../../data/_services";

const CardSection = () => (
  <Container>
    <Row justify="center" gutter={{ xs: 16, sm: 20, md: 24, lg: 20 }}>
      {cards.map((card, key) => (
        <Col key={key} xs={20} sm={12} md={8} lg={8}>
          <CustomCard
            type={card.type}
            title={card.title}
            imgSrc={card.imgSrc}
            content={card.content}
            contentTitle={card.contentTitle}
            btnText={card.btnText}
            bptop="20px"
            url={card.href}
          />
        </Col>
      ))}
    </Row>
  </Container>
);

export default CardSection;
